import { render, staticRenderFns } from "./DeleteGroupsErrorDialog.vue?vue&type=template&id=495b5087&scoped=true"
import script from "./DeleteGroupsErrorDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupsErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupsErrorDialog.vue?vue&type=style&index=0&id=495b5087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b5087",
  null
  
)

export default component.exports